import ImageWrapper from '@/components/image-wrapper'
import ImageHightLight1 from '@/assets/img/homepage/hight-light-1.png'
import ImageHightLight2 from '@/assets/img/homepage/hight-light-2.png'
import ImageHightLight3 from '@/assets/img/homepage/hight-light-3.png'
import ImageHightLight4 from '@/assets/img/homepage/hight-light-4.png'
import Styles from './style.module.scss'
import { Flex } from 'antd'

const TITLE = 'Highlights'
const data = [
  {
    title: 'Policy',
    image: ImageHightLight1,
    className: Styles.item1,
  },
  {
    title: 'Our Global footprint',
    image: ImageHightLight2,
    className: Styles.item2,
  },
  {
    title: 'Carus Flexible Finance and Operation Model',
    image: ImageHightLight3,
    className: Styles.item3,
  },
  {
    title: 'Energy Storage Systems',
    image: ImageHightLight4,
    className: Styles.item4,
  },
]

export default function HighLights() {
  return (
    <div className={Styles.highLights}>
      <h2>{TITLE}</h2>
      <Flex wrap className={Styles.content}>
        {data?.map((item, index) => (
          <ImageWrapper key={index} background={`url(${item.image}) no-repeat`} className={Styles.item}>
            <h5>{item.title}</h5>
          </ImageWrapper>
        ))}
      </Flex>
    </div>
  )
}
